module.exports = __webpack_public_path__ + "media/images/favicon-ad738bda6f70f993579b71ce32cf3662.ico";